angular.module('leanlaw').controller('DashboardCtrl', ['$scope', '$state', "userService", "accountingService", function ($scope, $state, userService, accountingService) {
  $scope.vm = {
    dateRangeOptions: undefined,
    me: undefined,
    showSwitchButton: true,
    status: {
      connected: false
    },
    showWarning: false
  };
  activate();

  /////////////////////////////

  async function activate() {
    $scope.vm.me = await userService.me();
    accountingService.verify(false).then(status => {
      $scope.vm.status = status;
    }).catch(status => {
      $scope.vm.status = status;
    }).finally(() => {
      if (!$scope.vm.status.connected && $scope.vm.me.company.products.trial) {
        $scope.vm.showWarning = true;
      } else {
        $scope.vm.showWarning = false;
      }
    });
    const {
      settings
    } = $scope.vm.me.company;
    $scope.vm.settings = settings;
    $scope.vm.matterTerm = $scope.vm.me.terms.Matter;
    $scope.vm.customFlagLabel = settings.labels && settings.labels.customFlag;
    const today = new Date();
    const endOfPreviousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    $scope.vm.dateRangeOptions = [{
      id: 'thisMonth',
      label: monthString(today.getMonth())
    }, {
      id: 'lastMonth',
      label: monthString(endOfPreviousMonth.getMonth())
    }, {
      id: 'thisYear',
      label: 'YTD'
    }];
  }
  $scope.report = (report, dateRangeId) => {
    $state.go(`reports.${report}`, dateRangeId);
  };
  $scope.generic = (id, params = {}) => {
    params.returnLabel = '';
    $state.go('reports.generic', {
      id,
      ...params
    });
  };
  function monthString(month) {
    return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][month];
  }
  $scope.closeSidebar = () => {
    $scope.vm.showSwitchButton = false;
    $scope.$emit('closeSidebar', true);
  };
}]);